import React from 'react';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import FileUploadComponentLabels from './file-upload-component-labels';
import ConditionId from './condition-id';

class FileField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = { ...prevState.model };
        model[fieldName] = value;
        return { model };
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <>
      <FieldLabel value={this.state.model.label} onChange={v => this.updateModel('label', v)} />
      <FieldHelpText value={this.state.model.helpText} onChange={v => this.updateModel('helpText', v)} />
      <FieldMandatory id={this.props.id}
                      value={this.state.model.mandatory}
                      onChange={v => this.updateModel('mandatory', v)}
                      conditionallyDisplayed={!!this.state.model.conditionId}/>
      <div className="mb-3">
        <label htmlFor="accept" className="form-label">File type restriction</label>
        <input id="accept" name="accept"
               type="text"
               className="form-control"
               value={this.state.model.accept || ''}
               onChange={e => this.updateModel('accept', e.target.value)}
               placeholder="e.g. image/png,image/jpeg" />
        <div className="form-text">If you wish to restrict the type of file, enter the MIME type(s) separated by a comma.</div>
      </div>
      <FieldWidth value={this.state.model.widthInPercent} onChange={v => this.updateModel('widthInPercent', v)} />
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
      <FileUploadComponentLabels value={this.state.model.componentLabels}
                                 onChange={v => this.updateModel('componentLabels', v)} />
    </>
  }

}

export default FileField;
